import Vue from "vue";
import VueRouter from "vue-router";

import FreeToolGrade from "../views/free-tools/grade.vue";
import LetterOfRecommendation from "../views/free-tools/letter_of_recommendation.vue";
import TongueTwister from "../views/free-tools/tongue_twister.vue";
import RoiCalculator from "../views/free-tools/roi_calculator.vue";
import FreeToolsAiDetection from "../views/free-tools/ai_detection.vue";
import FreeToolsSummarize from "../views/free-tools/summarize.vue";

Vue.use(VueRouter);

const routes = [
  // Free Tools
  {
    path: "/free-tools/grade",
    name: "free-tools-grade",
    component: FreeToolGrade,
  },

  {
    path: "/free-tools/letter-of-recommendation",
    name: "letter-of-recommendation",
    component: LetterOfRecommendation,
  },
  {
    path: "/free-tools/tongue-twister",
    name: "tongue-twister",
    component: TongueTwister,
  },
  {
    path: "/free-tools/roi-calculator",
    name: "roi-calculator-twister",
    component: RoiCalculator,
  },
  {
    path: "/free-tools/ai-detection",
    name: "free-tools-ai-detection",
    component: FreeToolsAiDetection,
  },
  {
    path: "/free-tools/summarize",
    name: "free-tools-summarize",
    component: FreeToolsSummarize,
  },
  {
    path: "*",
    redirect: "/free-tools/grade",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
